import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { setCondition } from '../../store/actions';
import ToggleCondition from '../ToggleCondition';
import useStyles from './styles';

function Title() {
  const { t } = useTranslation();
  const classes = useStyles();
  const condition = useSelector(state => state.get('condition'));
  const dispatch = useDispatch();

  return (
    <>
      <Grid container alignItems="center" justify="space-between">
        <Grid item component="label">
          <Typography variant="subtitle2">
            {t('filter-title')}
          </Typography>
        </Grid>

        <Grid item>
          <ToggleCondition
            condition={condition}
            setCondition={c => dispatch(setCondition(c))}
          />
        </Grid>
      </Grid>

      <Typography variant="body1" className={classes.detail}>
        {condition === 'OR' ? t('filter-or-detail') : t('filter-and-detail')}
      </Typography>

      <Divider />
    </>
  );
}

export default React.memo(Title);